import AbstractGuestlistDetailsPageController from './abstract-details-controller';
import guestlistEditAlertHandler from "../../../../../modules/guestlists/helpers/guestlist-edit-alert-handler";
import moment from "moment";

export default class GuestlistShortTermSettingsController extends AbstractGuestlistDetailsPageController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.navService = this.injector.get('NavService');
        this.filter = this.injector.get('$filter');
        this.depositService = this.injector.get('Deposit');

        this.loading = true;
        this.guestlist = null;
        this.seatplan = null;

        this.shortTermBookableElements = {};
        this.currentSelectedElements = [];
        this.bookingInformation = {};

        this.registrationStart = null;
        this.registrationEnd = null;

        this.model = {
            short_term_max_pax: 10,
            short_term_min_pax: 2,
            short_term_pax_buffer: 2,
            short_term_reservation_registration_allow_multiple: false,
            short_term_seatplan_elements: [],
            short_term_status: 'optional',
            short_term_time_slots: []
        }

        this.currentGroup = false;
        this.availableStates = [];
        this.depositService.getRemoteDeposit('rsvps', 'states', []).then((value) => {
            this.availableStates = value;
            this.scope.$applyAsync();
        });
    }

    // Public functions
    activateGroup(group) {
        this.currentGroup = group.id;
        this._updateCustomActions();
        if (this.shortTermBookableElements[group.id]) {
            this.currentSelectedElements = this.shortTermBookableElements[group.id];
        } else {
            this.currentSelectedElements = [];
        }
    }

    save() {
        this.loading = true;

        this.api
            .put(
                `guestlists/${this.guestlist.id}/settings`,
                {
                    settings: this._prepareDataForSaving(),
                },
                {
                    headers: {
                        'x-festzelt-os-guestlist-version-hash': this.guestlist.version_hash
                    }
                }
            )
            .then(() => {
                this._loadGuestlist();
                this.submitting = false;
            })
            .catch(e => {
                return guestlistEditAlertHandler(this.injector, e)
                    .catch((e) => {
                        this.alert.handle(e);
                    })
                    .finally(() => {
                        this.submitting = false;
                        return this._loadGuestlist();
                    });
            });
    }

    handleSeatplanSelectionChange(triggeredElement, selectionState, allSelectedElements) {
        this.scope.$applyAsync(() => {
            this.shortTermBookableElements[this.currentGroup] = [];
            _.each(allSelectedElements, (element) => {
                this.shortTermBookableElements[this.currentGroup].push(element.id);
            });

            this.currentSelectedElements = this.shortTermBookableElements[this.currentGroup];
        });
    }

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();
        this.loading = true;


        this.registrationStart = moment(this.guestlist.settings.short_term_registration_start);
        this.registrationEnd = moment(this.guestlist.settings.short_term_registration_end);

        this.model = {
            short_term_max_pax: this.guestlist.settings.short_term_max_pax,
            short_term_min_pax: this.guestlist.settings.short_term_min_pax,
            short_term_pax_buffer: this.guestlist.settings.short_term_pax_buffer,
            short_term_reservation_registration_allow_multiple: this.guestlist.settings.short_term_reservation_registration_allow_multiple,
            short_term_seatplan_elements: this.guestlist.settings.short_term_seatplan_elements,
            short_term_status: this.guestlist.settings.short_term_status,
            short_term_time_slots: this.guestlist.settings.short_term_time_slots
                .map((original) => {
                    const startSplit = original.start.split(':'),
                        endSplit = original.end.split(':')

                    return {
                        start: moment().utc().hour(startSplit[0]).minute(startSplit[1]).local().format('HH:mm'),
                        end: moment().utc().hour(endSplit[0]).minute(endSplit[1]).local().format('HH:mm')
                    }
                }),
        }

        this.injector
            .get('$q')
            .all([
                this.api
                    .get(`seatplans/${this.guestlist.seatplan_id}?include=groups,groups.elements,areas`)
                    .then(({data}) => {
                        this.seatplan = _.cloneDeep(data.data)
                        this._updateAlreadyDefinedSeatplanElements()

                        this.loading = false;
                    }),

            ])
            .then(() => {
                this.activateGroup(this.seatplan.groups.data[0]);
                this._updateCustomActions();
                this.loading = false;
            });
    }

    // Internal functions
    _updateAlreadyDefinedSeatplanElements() {
        this.shortTermBookableElements = {};

        this.seatplan.groups.data.forEach((group) => {
            const curGroupElements = [];

            group.elements.data.forEach((element) => {
                if (this.model.short_term_seatplan_elements.includes(element.id)) {
                    curGroupElements.push(element.id);
                }
            });

            this.shortTermBookableElements[group.id] = curGroupElements;
        })
    }

    _prepareDataForSaving() {
        const out = {
            ...this.model,
            short_term_seatplan_elements: [],
            short_term_registration_start: moment(this.registrationStart).tz('UTC').format(),
            short_term_registration_end: moment(this.registrationEnd).tz('UTC').format(),
            short_term_time_slots: this.model
                .short_term_time_slots
                .sort((a, b) => {
                    const aSplit = a.start.split(':'),
                        bSplit = b.start.split(':')

                    if (aSplit[0] !== bSplit[0]) {
                        return aSplit[0].localeCompare(bSplit[0])
                    }

                    return aSplit[1].localeCompare(bSplit[1])
                })
                .map((original) => {
                    const startSplit = original.start.split(':'),
                        endSplit = original.end.split(':')

                    return {
                        start: moment().hour(startSplit[0]).minute(startSplit[1]).tz('UTC').format('HH:mm'),
                        end: moment().hour(endSplit[0]).minute(endSplit[1]).tz('UTC').format('HH:mm')
                    }
                }),

        };

        _.each(this.shortTermBookableElements, (elementIds) => {
            if (_.isArray(elementIds) && elementIds.length > 0) {
                out.short_term_seatplan_elements = out.short_term_seatplan_elements.concat(elementIds);
            }
        });

        return out;
    }

    _updateCustomActions() {
        this.navService.shouldShowBackBtn(false);
        const customs = [];
        _.each(this.seatplan.groups.data, (group) => {
            customs.push({
                label: group.title,
                key: 'group-' + group.id,
                icon: 'char-' + group.title[0].toLowerCase(),
                order: group.title[0].toLowerCase(),
                action: () => {
                    this.activateGroup(group);
                },
                active: group.id === this.currentGroup
            });
        });

        this.navService.setSideNavCustoms(customs);
    }

    addNewTimeSlot() {
        this.model.short_term_time_slots.push({
            start: '09:00',
            end: '11:00'
        });
    }

    removeTimeSlot(index) {
        this.model.short_term_time_slots.splice(index, 1);
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/short-term-settings-controller.js